// src/components/Dashboard.tsx

import { useAuth } from '../hooks/useAuth';
import { Analytics } from './Analytics';

export function Dashboard() {
  const { user } = useAuth();

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="mb-8">
          <h1 className="text-3xl font-bold">Welcome back, {user?.email}</h1>
          <p className="text-gray-600 mt-2">
            Manage your Instagram DM automation
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-8">
          <div className="bg-white p-6 rounded-lg shadow">
            <h3 className="text-lg font-semibold mb-2">Current Plan</h3>
            <p className="text-2xl font-bold">
              {user?.subscription?.planName || 'Free'}
            </p>
          </div>

          <div className="bg-white p-6 rounded-lg shadow">
            <h3 className="text-lg font-semibold mb-2">Status</h3>
            <p className="text-lg">
              {user?.subscription?.status || 'Active'}
            </p>
          </div>

          <div className="bg-white p-6 rounded-lg shadow">
            <h3 className="text-lg font-semibold mb-2">Account</h3>
            <p className="text-sm text-gray-600">{user?.email}</p>
          </div>
        </div>

        <Analytics />
      </div>
    </div>
  );
}
